export default __webpack_public_path__ + "static/media/logo.a0a1d255.png";